
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/rewrite/anon",
      function () {
        return require("private-next-pages/home/rewrite/anon.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/rewrite/anon"])
      });
    }
  